<template>
  <div>
    <v-bottom-sheet v-model="requerideCookies" hide-overlay persistent attach>
      <div class="cookies-banner">
        <div class="cookies-banner-icon">
          <v-icon size="22" color="#0277BD">mdi-cookie-outline</v-icon>
        </div>
        <div class="cookies-banner-text" v-html="$t('cookiesRequiredInfo')"></div>
        <div class="cookies-banner-actions">
          <button type="button" class="cookies-btn-ghost" @click="managePreferences">
            {{ $t('manageCookiesPreferencies') }}
          </button>
          <button type="button" class="cookies-btn-outline" @click="rejectAllCookies">
            {{ $t('rejectCookiesPreferencies') }}
          </button>
          <button type="button" class="cookies-btn-primary" @click="acceptAllCookies">
            {{ $t('acceptAllCookiesPreferencies') }}
          </button>
        </div>
      </div>
    </v-bottom-sheet>
    <v-dialog width="600" v-model="dialog" persistent attach>
      <div class="cookies-dialog-card">
        <div class="cookies-dialog-header">
          <img src="/images/logo/logo-04.png" alt="migly" width="76"/>
          <button type="button" class="cookies-close-btn" @click="dialog = false">
            <v-icon size="18" color="#7E8EA6">mdi-close</v-icon>
          </button>
        </div>
        <h3 class="cookies-dialog-title">{{ $t('manageCookiesTitle') }}</h3>
        <p class="cookies-dialog-description" v-html="$t('manageCookiesDescription')"></p>

        <div class="cookies-pref-row" v-for="field, index in ['necessary', 'analytics', 'advertising', 'research']" :key="field">
          <div class="cookies-pref-row-head">
            <span class="cookies-pref-label">{{ $t(`cookie_${field}`) }}</span>
            <v-switch
              v-model="preferences[field]"
              inset
              hide-details
              color="#0277BD"
              class="ma-0 pa-0 cookies-pref-switch"
              :disabled="index == 0"
            />
          </div>
          <p class="cookies-pref-desc">
            {{ $t(`cookie_${field}_desc`) }}
          </p>
        </div>
        <div class="cookies-dialog-actions">
          <button type="button" class="cookies-btn-primary cookies-btn-block" @click="confirm()">
            {{ $t('toConfirm') }}
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
  export default {
    name: 'Cookies',
    props: [],
    components: {
    },
    data: () => ({
      dialog: false,
      requerideCookies: true,
      cookiesAccepted: false,
      preferences: {
        necessary: true,
        analytics: true,
        advertising: false,
        research: true
      }
    }),
    mounted: function() {
      this.setId()
      this.cookiesAccepted = !!this.$cookies.get('preferences');
      if(this.cookiesAccepted)
        this.requerideCookies = false
    },
    computed: {

    },
    methods: {
      acceptAllCookies() {
        this.$cookies.set('preferences', JSON.stringify({
          necessary: true,
          analytics: true,
          advertising: true,
          research: true
        }), { expires: 365 });
        this.cookiesAccepted = true;
        this.requerideCookies = false;
        this.dialog = false
      },
      rejectAllCookies() {
        this.$cookies.set('preferences', JSON.stringify({
          necessary: true,
          analytics: false,
          advertising: false,
          research: false
        }), { expires: 365 });
        this.cookiesAccepted = true;
        this.requerideCookies = false;
        this.dialog = false
      },
      managePreferences() {
        this.dialog = true
      },
      confirm: function() {
        this.$cookies.set('preferences', JSON.stringify(this.preferences), { expires: 365 });
        this.cookiesAccepted = true;
        this.requerideCookies = false;
        this.dialog = false
      },
      setId: function() {
        if(!this.$cookies.get('_migly'))
          this.$cookies.set('_migly', uuidv4());
      }
    },
  }
</script>
<style scoped>
.cookies-banner {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  background: #FFFFFF;
  font-family: 'Montserrat', sans-serif;
  padding: 1.5rem 2rem;
  border-top: 1px solid rgba(16,24,39,0.08);
  box-shadow: 0 -12px 30px rgba(16,24,39,0.06);
}
.cookies-banner-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #E3F1FA;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cookies-banner-text {
  flex: 1;
  min-width: 240px;
  color: #5B6472;
  font-size: 0.85rem;
  line-height: 1.6;
}
.cookies-banner-text ::v-deep .link {
  color: #0277BD;
  font-weight: 700;
  text-decoration: none;
}
.cookies-banner-text ::v-deep .link:hover {
  text-decoration: underline;
}
.cookies-banner-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-shrink: 0;
  flex-wrap: wrap;
}

/*
 * Below 600px the banner's fixed horizontal row (icon + text with a
 * 240px min-width + the action buttons) no longer fits the viewport and
 * pushes "Rejeitar"/"Aceitar" fully off-screen. Restack vertically so
 * every control stays reachable without introducing horizontal scroll.
 */
@media (max-width: 600px) {
  .cookies-banner {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1.25rem 1.25rem 1.5rem;
  }
  .cookies-banner-text {
    min-width: 0;
    width: 100%;
  }
  .cookies-banner-actions {
    width: 100%;
    justify-content: flex-start;
  }
  .cookies-btn-ghost,
  .cookies-btn-outline,
  .cookies-btn-primary {
    flex: 1 1 auto;
    text-align: center;
  }
}
.cookies-btn-ghost {
  border: none;
  background: transparent;
  color: #5B6472;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.82rem;
  padding: 0.65rem 0.9rem;
  cursor: pointer;
  transition: color 0.2s ease;
  white-space: nowrap;
}
.cookies-btn-ghost:hover {
  color: #0277BD;
}
.cookies-btn-outline {
  border: 1px solid rgba(2, 119, 189, 0.35);
  background: #FFFFFF;
  color: #0277BD;
  border-radius: 999px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.82rem;
  padding: 0.65rem 1.2rem;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  white-space: nowrap;
}
.cookies-btn-outline:hover {
  background: #E3F1FA;
  transform: translateY(-1px);
}
.cookies-btn-primary {
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #00BDB3 0%, #0277BD 100%);
  color: #FFFFFF;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.82rem;
  padding: 0.65rem 1.3rem;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 8px 18px rgba(2, 119, 189, 0.28);
  white-space: nowrap;
}
.cookies-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(2, 119, 189, 0.38);
}
.cookies-btn-block {
  display: block;
  width: 100%;
  text-align: center;
}

.cookies-dialog-card {
  font-family: 'Montserrat', sans-serif;
  background: #FFFFFF;
  border-radius: 1.5rem;
  padding: 1.75rem 2rem 2rem;
  max-height: 85vh;
  overflow-y: auto;
}
.cookies-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.cookies-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #F7F5EF;
  cursor: pointer;
  transition: background 0.2s ease;
}
.cookies-close-btn:hover {
  background: #E3F1FA;
}
.cookies-dialog-title {
  font-weight: 900;
  font-size: 1.15rem;
  color: #101827;
  margin: 0.5rem 0 0.6rem;
}
.cookies-dialog-description {
  color: #5B6472;
  font-size: 0.85rem;
  line-height: 1.65;
  margin: 0 0 1.5rem;
}
.cookies-pref-row {
  padding: 1rem 0;
  border-top: 1px solid rgba(16,24,39,0.08);
}
.cookies-pref-row:last-of-type {
  border-bottom: 1px solid rgba(16,24,39,0.08);
}
.cookies-pref-row-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.cookies-pref-label {
  font-weight: 700;
  font-size: 0.92rem;
  color: #101827;
}
.cookies-pref-switch ::v-deep .v-input--selection-controls__input {
  margin-right: 0;
}
.cookies-pref-desc {
  color: #7E8EA6;
  font-size: 0.8rem;
  line-height: 1.55;
  margin: 0.4rem 0 0;
}
.cookies-dialog-actions {
  margin-top: 1.75rem;
}
</style>